(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7710],{

/***/ 47710:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ viewed; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./components/index.js + 174 modules
var components = __webpack_require__(29435);
// EXTERNAL MODULE: ./lib/getProductWithoutQuantity.js
var getProductWithoutQuantity = __webpack_require__(3506);
// EXTERNAL MODULE: ./seo/Ecommerce.js
var Ecommerce = __webpack_require__(31893);
// EXTERNAL MODULE: ./containers/viewed/Viewed.module.scss
var Viewed_module = __webpack_require__(66211);
var Viewed_module_default = /*#__PURE__*/__webpack_require__.n(Viewed_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./containers/viewed/Viewed.js


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }









var RowSlider = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 7266).then(__webpack_require__.bind(__webpack_require__, 87266));
}, {
  loading: function loading() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Loader */.aN, {});
  },
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(87266)];
    }
  }
});
var Viewed = /*#__PURE__*/(0,react.memo)(function (_ref) {
  var products = _ref.products,
      currency = _ref.currency,
      firstProductId = _ref.firstProductId,
      setFirstProductId = _ref.setFirstProductId;
  (0,react.useEffect)(function () {
    var _products$, _products$$model;

    if (Object.keys(currency).length > 0 && products && products.length && firstProductId !== ((_products$ = products[0]) === null || _products$ === void 0 ? void 0 : (_products$$model = _products$.model) === null || _products$$model === void 0 ? void 0 : _products$$model.id)) {
      var _products$2, _products$2$model;

      if (!!((_products$2 = products[0]) !== null && _products$2 !== void 0 && (_products$2$model = _products$2.model) !== null && _products$2$model !== void 0 && _products$2$model.id)) {
        setFirstProductId(products[0].model.id);
      }

      Ecommerce/* default.viewItemList */.ZP.viewItemList((0,getProductWithoutQuantity/* default */.Z)(products), currency, 'Вы недавно просматривали');
    }
  }, [currency, products, firstProductId]);

  var handleClickCard = function handleClickCard(product, index) {
    var newProducts = (0,getProductWithoutQuantity/* default */.Z)([product]);
    Ecommerce/* default.viewItemList */.ZP.viewItemList(newProducts, currency, 'Вы недавно просматривали', 'select_item', index);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
    className: (Viewed_module_default()).viewed,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (Viewed_module_default()).viewedTitle,
      children: "\u0412\u044B \u043D\u0435\u0434\u0430\u0432\u043D\u043E \u043F\u0440\u043E\u0441\u043C\u0430\u0442\u0440\u0438\u0432\u0430\u043B\u0438"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(RowSlider, {
      arrowsOutside: true,
      viewedProduct: true,
      children: products.map(function (product, idx) {
        var _product$model;

        return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          onClick: function onClick() {
            handleClickCard(product, idx + 1);
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ProductCard */.Il, _objectSpread(_objectSpread({}, product), {}, {
            mod: "viewed",
            pageName: 'Вы недавно просматривали',
            indexCard: idx + 1
          }))
        }, (product === null || product === void 0 ? void 0 : (_product$model = product.model) === null || _product$model === void 0 ? void 0 : _product$model.id) || idx);
      })
    })]
  });
});
/* harmony default export */ var viewed_Viewed = (Viewed);
;// CONCATENATED MODULE: ./containers/viewed/index.js

/* harmony default export */ var viewed = (viewed_Viewed);

/***/ }),

/***/ 66211:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"viewed":"Viewed_viewed__AvEtD","viewedTitle":"Viewed_viewedTitle__lYUIH","load":"Viewed_load__iE2U0"};

/***/ })

}]);